import React from 'react';
import { TextField } from '@mui/material';
import { BaseFilterComponentProps } from './types';

export const InputFilter = <TableEntity,>({ filter, onChange }: BaseFilterComponentProps<TableEntity, string>) => {
  return (
    <TextField
      slotProps={{
        input: {
          size: 'small',
          sx: {
            height: 28.5,
            '& .MuiInputBase-root': {
              height: 28.5,
            },
            '& .MuiInputBase-input': {
              padding: '6px 8px',
              height: '20px',
              boxSizing: 'border-box',
            },
          },
        },
      }}
      placeholder="Search..."
      fullWidth
      onChange={event => onChange(event.target.value)}
      value={filter?.value ?? ''}
    />
  );
};
